<template>
  <div id="app">
    <CreditCard/>

    <footer class="footer">
      <div class="content has-text-centered is-size-7">
        <strong>KUBOKTO SRL</strong> P.IVA 04500490406
      </div>
    </footer>
  </div>
</template>

<script>
import CreditCard from "./views/CreditCard.vue";

export default {
  name: "appvue",
  components: { CreditCard }
};
</script>


<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

footer.footer {
  margin-top: 80px;
}
</style>